// AJAX Cart Functionality - More Robust Version
(function() {
  'use strict';

  class AjaxCart {
    constructor() {
      this.notification = document.querySelector('cart-notification');
      this.notificationElement = document.getElementById('cart-notification');
      this.notificationProduct = document.getElementById('cart-notification-product');
      this.notificationButton = document.getElementById('cart-notification-button');

      this.init();
    }

    init() {
      // Use event delegation to catch all form submissions
      document.addEventListener('submit', (e) => {
        // Check if it's a cart add form
        if (e.target.matches('.spf-product__form') ||
            e.target.matches('form[action*="/cart/add"]')) {
          e.preventDefault();
          e.stopPropagation();
          this.addToCart(e.target);
        }
      }, true); // Use capture phase

      // Close notification buttons
      if (this.notification) {
        const closeButton = this.notification.querySelector('.cart-notification__close');
        const continueButton = this.notification.querySelector('.link.button-label');

        if (closeButton) {
          closeButton.addEventListener('click', () => this.hideNotification());
        }

        if (continueButton) {
          continueButton.addEventListener('click', () => this.hideNotification());
        }
      }

      console.log('AJAX Cart initialized');
    }

    async addToCart(form) {
      console.log('Adding to cart...', form);

      const submitButton = form.querySelector('[type="submit"]');
      const buttonSpan = submitButton.querySelector('span');
      const originalButtonText = buttonSpan ? buttonSpan.textContent : submitButton.textContent;

      // Disable button and show loading state
      submitButton.disabled = true;
      if (buttonSpan) {
        buttonSpan.textContent = 'Adding...';
      } else {
        submitButton.textContent = 'Adding...';
      }

      // Get form data
      const formData = new FormData(form);

      // Ask Shopify to return the re-rendered cart icon bubble so we can update the
      // header count immediately (fixes the count only updating on page reload).
      formData.append('sections', 'cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || 'Failed to add to cart');
        }

        const item = await response.json();
        console.log('Item added:', item);

        // Update the header cart count bubble straight away using the returned section HTML
        this.renderCartIconBubble(item.sections);

        // Show notification with product details
        await this.showNotification(item);

        // Update cart count (fires cart:updated for any other listeners)
        await this.updateCartCount();

        // Re-enable button
        submitButton.disabled = false;
        if (buttonSpan) {
          buttonSpan.textContent = originalButtonText;
        } else {
          submitButton.textContent = originalButtonText;
        }

      } catch (error) {
        console.error('Error adding to cart:', error);
        alert(error.message || 'There was an error adding the item to your cart. Please try again.');

        // Re-enable button
        submitButton.disabled = false;
        if (buttonSpan) {
          buttonSpan.textContent = originalButtonText;
        } else {
          submitButton.textContent = originalButtonText;
        }
      }
    }

    async showNotification(item) {
      if (!this.notification || !this.notificationElement) {
        console.warn('Cart notification element not found');
        return;
      }

      // Populate notification with product details
      this.notificationProduct.innerHTML = this.renderCartItem(item);

      // Update the view cart button with cart count
      const cart = await this.getCart();
      this.notificationButton.textContent = `View my cart (${cart.item_count})`;

      // Show the notification
      this.notificationElement.style.display = 'block';

      // Animate in
      setTimeout(() => {
        this.notificationElement.classList.add('animate', 'active');
      }, 10);

      // Auto-hide after 5 seconds
      setTimeout(() => {
        this.hideNotification();
      }, 5000);
    }

    hideNotification() {
      if (!this.notificationElement) return;

      this.notificationElement.classList.remove('active');

      setTimeout(() => {
        this.notificationElement.style.display = 'none';
        this.notificationElement.classList.remove('animate');
      }, 300);
    }

    renderCartItem(item) {
      const price = this.formatMoney(item.price);
      const linePrice = this.formatMoney(item.line_price);

      return `
        <div class="cart-notification-product__info">
          <div class="cart-notification-product__image">
            ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">` : ''}
          </div>
          <div class="cart-notification-product__details">
            <h3 class="cart-notification-product__name h4">${item.product_title}</h3>
            ${item.variant_title ? `<div class="cart-notification-product__variant">${item.variant_title}</div>` : ''}
            <div class="cart-notification-product__price">
              <span class="price">${price}</span>
              ${item.quantity > 1 ? `<span class="quantity"> × ${item.quantity} = ${linePrice}</span>` : ''}
            </div>
          </div>
        </div>
      `;
    }

    // Re-render the header cart count bubble from a Shopify sections response
    renderCartIconBubble(sections) {
      if (!sections) return;
      const html = sections['cart-icon-bubble'];
      const target = document.getElementById('cart-icon-bubble');
      if (!html || !target) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const source = doc.querySelector('.shopify-section') || doc.body;
      target.innerHTML = source.innerHTML;
    }

    async getCart() {
      try {
        const response = await fetch('/cart.js');
        return await response.json();
      } catch (error) {
        console.error('Error fetching cart:', error);
        return { item_count: 0 };
      }
    }

    async updateCartCount() {
      const cart = await this.getCart();

      // Update any legacy cart count elements that use these classes/attributes
      const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count], .count-bubble');
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
        if (cart.item_count > 0) {
          element.style.display = '';
        }
      });

      // Dispatch custom event for other scripts
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart }
      }));
    }

    formatMoney(cents) {
      // Format money in cents to Rands
      const amount = (cents / 100).toFixed(2);
      return `R${amount}`;
    }
  }

  // Initialize immediately when script runs
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.ajaxCart = new AjaxCart();
    });
  } else {
    window.ajaxCart = new AjaxCart();
  }

  // --- Global cart-count watcher --------------------------------------------------
  // Any script on the site (Globo collection cards, Mix Kit, quick add, the theme's own
  // product form, etc.) that mutates the cart via fetch or XHR will trigger a refresh of
  // the header cart-count bubble. This makes the count update in real time everywhere,
  // regardless of which script performed the add.
  function refreshCartBubble() {
    fetch(window.location.pathname + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-icon-bubble'];
        var target = document.getElementById('cart-icon-bubble');
        if (!html || !target) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var source = doc.querySelector('.shopify-section') || doc.body;
        target.innerHTML = source.innerHTML;
      })
      .catch(function () {});
  }

  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  if (window.fetch && !window.__cartBubbleFetchPatched) {
    window.__cartBubbleFetchPatched = true;
    var _origFetch = window.fetch;
    window.fetch = function () {
      var arg = arguments[0];
      var url = (arg && arg.url) ? arg.url : arg;
      var isCart = typeof url === 'string' && CART_MUTATION.test(url);
      var p = _origFetch.apply(this, arguments);
      if (isCart) { p.then(function () { setTimeout(refreshCartBubble, 300); }).catch(function () {}); }
      return p;
    };
  }

  if (!window.__cartBubbleXHRPatched) {
    window.__cartBubbleXHRPatched = true;
    var _origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try { this.__cartMutation = typeof url === 'string' && CART_MUTATION.test(url); } catch (e) {}
      return _origOpen.apply(this, arguments);
    };
    var _origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__cartMutation) {
        this.addEventListener('load', function () { setTimeout(refreshCartBubble, 300); });
      }
      return _origSend.apply(this, arguments);
    };
  }

})();
